import { render, staticRenderFns } from "./ResponsiveModal.vue?vue&type=template&id=44b07bdf&scoped=true&"
import script from "./ResponsiveModal.vue?vue&type=script&lang=js&"
export * from "./ResponsiveModal.vue?vue&type=script&lang=js&"
import style0 from "./ResponsiveModal.vue?vue&type=style&index=0&id=44b07bdf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b07bdf",
  null
  
)

export default component.exports